var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"good-simple"},[_vm._t("img"),_vm._t("title"),_vm._t("info")],2)}
var staticRenderFns = []

export { render, staticRenderFns }